import { render, staticRenderFns } from "./LeaderboardTeamContent.vue?vue&type=template&id=131730c4&scoped=true&"
import script from "./LeaderboardTeamContent.vue?vue&type=script&lang=js&"
export * from "./LeaderboardTeamContent.vue?vue&type=script&lang=js&"
import style0 from "./LeaderboardTeamContent.vue?vue&type=style&index=0&id=131730c4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "131730c4",
  null
  
)

export default component.exports